import $ from 'jquery';

function isDesktop() {
  return window.matchMedia('(min-width: 768px)').matches;
}

const onControlChanges = (control) => {
  const $this = $(control);
  const options = $this.find('option');

  if ($this.is('select') && options.length > 0) {
    options.each((index, option) => {
      if ($(option).attr('selected') === 'selected') {
        if ($(option).val() !== 'All') {
          $this.addClass('selected');
          return;
        }
        $this.removeClass('selected');
      }
    });
  }

  if ($this.is('input')) {
    if ($this.val()) {
      $this.addClass('selected');
      return;
    }
    $this.removeClass('selected');
  }
};

const showFilter = (form, height, btnHide, btnShow, animate = true) => {
  form.css({
    overflow: 'visible',
    height: `${height}px`,
    transition: animate ? 'height .3s ease-in-out' : 'none',
  });

  btnHide.addClass('shown');
  btnShow.removeClass('shown');
};

const toggleTabindex = (controls, tabindex) => {
  $(controls).each((index, control) => {
    $(control).attr('tabindex', tabindex);
  });
};

const hideFilter = (form, btnHide, btnShow) => {
  form.css({
    height: 0,
    transition: 'height .3s linear',
    overflow: 'hidden',
  });

  btnHide.removeClass('shown');
  btnShow.addClass('shown');
};

const initCalendarFilter = (el) => {
  const $form = $(el);
  const $parent = $form.parent('.calendar-filter, .archive-filter');

  const secondaryFilterToggler = $('button[data-action="show-sidebar"]');

  const secondaryFilterWrapper = $('.calendar-filter__secondary');

  const primaryFilterOptions = $form.children('.form-item');
  const primaryFilterControls = primaryFilterOptions.find('select, input');
  const secondaryFilterControls = secondaryFilterWrapper.find('input');
  const $textfields = $form.find('input[type="text"]');

  if ($textfields.length) {
    const $cleanTextfieldButton = $('<button>', {
      type: 'button',
      class: ['btn', 'btn--icon-close', 'btn-reset-textfield'].join(' '),
      'aria-label': 'Rensa fält',
      value: 'Rensa fält',
    });

    $cleanTextfieldButton.hide();

    const $textFieldItem = $form.find('.js-form-type-textfield');
    $textFieldItem.append($cleanTextfieldButton);

    const handleClickResetBtn = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const { target } = e;
      const $textField = $(target).siblings('input[type="text"]');
      $textField.val('');
      // Find and click the submit button that has the AJAX handler
      const $submitButton = $form.find('input[type="submit"], button[type="submit"]');
      if ($submitButton.length) {
        $submitButton[0].click();
      }
    };

    $cleanTextfieldButton.on('click', handleClickResetBtn);

    $textfields.on('input focus', (e) => {
      const { target } = e;
      const $resetBtn = $(target).siblings('.btn-reset-textfield');
      const value = $(target).val();
      if (value) {
        $resetBtn.show();
      } else {
        $resetBtn.hide();
      }
    });
  }

  let formHeight = 0;

  primaryFilterOptions.each((index, item) => {
    if ($parent.hasClass('archive-filter')) {
      formHeight += $(item).outerHeight();
      formHeight += 24 - 24 / primaryFilterOptions.length;
    } else {
      formHeight += $(item).outerHeight() + 44;
    }
  });

  const btnShowFilter = $('button[data-action="show-filter"]');

  const btnHideFilter = $('button[data-action="hide-filter"]');

  const primaryFilterWrapper = $('<div class="calendar-filter__primary" />');

  if (!isDesktop()) {
    $form.detach(primaryFilterOptions);
    primaryFilterWrapper.append(primaryFilterOptions);

    $form.prepend(primaryFilterWrapper);

    $form.css({ height: 0, overflow: 'hidden' });
    btnShowFilter.addClass('shown');

    toggleTabindex(primaryFilterControls, '-1');
  }
  const width = $(window).width();

  $(window).on('resize', () => {
    if ($(this).width() !== width && window.outerWidth >= 768) {
      $form.prepend(primaryFilterOptions);
      primaryFilterWrapper.hide();
      btnShowFilter.removeClass('shown');
      btnHideFilter.removeClass('shown');

      secondaryFilterToggler.show();
      $form.css({ height: 'auto', overflow: 'visible' });

      toggleTabindex(primaryFilterControls, '');
    }

    if ($(this).width() !== width && window.outerWidth < 768) {
      $form.detach(primaryFilterOptions);

      primaryFilterWrapper.append(primaryFilterOptions);
      $form.prepend(primaryFilterWrapper);
      primaryFilterWrapper.show();

      $form.css({ height: 0, overflow: 'hidden' });
      btnShowFilter.addClass('shown');

      toggleTabindex(primaryFilterControls, '-1');
      toggleTabindex(secondaryFilterControls, '-1');
    }
  });

  $parent.css({
    height: 'auto',
    overflow: 'visible',
    opacity: 1,
  });

  btnShowFilter.on('click keypress', () => {
    showFilter($form, formHeight, btnHideFilter, btnShowFilter);
    toggleTabindex(primaryFilterControls, '');
  });

  btnHideFilter.on('click keypress', () => {
    hideFilter($form, btnHideFilter, btnShowFilter);
    toggleTabindex(primaryFilterControls, '-1');
  });

  primaryFilterControls.each((index, item) => {
    onControlChanges(item);
  });

  secondaryFilterControls.each((index, control) => {
    $(control).on('click keypress', () => {
      secondaryFilterWrapper.attr('data-expanded', true);
      secondaryFilterWrapper.addClass('is-open');
    });
  });

  if (!isDesktop() && primaryFilterControls.filter('.selected').length > 0) {
    showFilter($form, formHeight, btnHideFilter, btnShowFilter, false);
  }

  const sidebarHtml = secondaryFilterWrapper.get(0);

  if (sidebarHtml) {
    const config = { attributes: true };

    const callback = (mutationList) => {
      mutationList.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-expanded') {
          if (sidebarHtml.dataset.expanded === 'true') {
            toggleTabindex(secondaryFilterControls, '0');
          } else {
            toggleTabindex(secondaryFilterControls, '-1');
          }
        }
      });
    };

    const observer = new MutationObserver(callback);

    observer.observe(sidebarHtml, config);
  }
};

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstCalendarFilter = {
    attach(context) {
      $(once('calendarForm', '#views-exposed-form-calender-calendar-page', context)).each(
        (index, element) => initCalendarFilter(element),
      );
    },
  };

  Drupal.behaviors.mstArchiveProdFilter = {
    attach(context) {
      $(
        once(
          'archiveFormProduction',
          '#views-exposed-form-archive-production-archive-production',
          context,
        ),
      ).each((index, element) => initCalendarFilter(element));
    },
  };

  Drupal.behaviors.mstArchiveTeamFilter = {
    attach(context) {
      $(once('archiveFormTeam', '#views-exposed-form-archive-team-archive-team', context)).each(
        (index, element) => initCalendarFilter(element),
      );
    },
  };
}(window, Drupal));
